import Model from './Model'

export default class LabourRate extends Model {
    getFormAttributes() {
        const attributes = this.only(['name', 'uom', 'unit_per_hour', 'buy_day_rate', 'sell_day_rate', 'buy_hours_in_shift', 'sell_hours_in_shift'])
        attributes.group_name = {label: this.group_name, value: this.group_name}
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes.group_name = attributes.group_name?.value
        return attributes
    }

    toDropdown() {
        return {name: this.name, value: this.key()}
    }

    static async search(query) {
        const params = {query}
        const config = {params: params}
        const {data} = await Http.get(route('api.v1.labour-rates.index'), config)
        return this.make(data)
    }


    static async all(params = {}) {
        const config = {params: params}
        const {data} = await Http.get(route('api.v1.labour-rates.index'), config)
        return this.make(data)
    }

    static async groups() {
        return await Http.get(route('api.v1.labour-rates.groups'))
    }

    static async price(rateId, estimateId = null) {
        const config = {params: {labour_rate_id: rateId}}


        if (_.isNumber(estimateId)) {
            config.params.estimate_id = estimateId
        }

        const {data} = await Http.get(route('api.v1.labour-rates.price'), config)
        return data;
    }

    static async create(attributes) {
        const url = route('api.v1.labour-rates.store')
        const {data} = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v1.labour-rates.update', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const {data} = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v1.labour-rates.destroy', this.id))
    }
}
